<template>
  <div id="app">
    <div class="heading">
      <a class="smallest" href="/"><img class="caadlab-logo" src="@/assets/CAADLab.png" alt="CAADLab Logo"></a>
      <h1 class="heading-title"> Computer Architecture and Automated Design Lab </h1>
      <img class="heading-bu smallest"  src="@/assets/Boston_University.png" alt="Boston university logo"/>
    </div>
    <hr class="smallest">
    <NavBar />
    <router-view/>
    <hr>
    <div class="footer">
        <span> Copyright ©2004-2020 All rights reserved </span>
        <!-- <span> <a href="https://www.bu.edu/caadlab/index.html">CAAD Lab Home </a></span> -->
        <span> Boston University - Electrical and Computer Engineering Department</span>
        <span> Updated July 30 2020 </span>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";

export default {
    components: {
        NavBar,
    }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Serif:ital,wght@0,400;0,700;1,400&family=Montserrat:ital,wght@0,400;0,600;1,500;1,600&family=Play:wght@400;700&family=Open+Sans:wght@400;700&display=swap');
#app {
    /* min-width: 46rem; */
    max-width: 1200px;
    margin: auto;
    color: #2c3e50;
    padding: 1rem;
}

.heading {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;
  /* BACKGROUND-IMAGE: URL("../assets/back2.gif"); */
}
.caadlab-logo{
  height: 75px;
}
.heading-title {
  text-align: center;
  font-size: 24px;
  margin: 0;
  order: 1;
}
.heading-bu{
  height: 75px;
  flex: none;
}

.smallest{
  display: auto;
}

h1,
h2,
h3,
h4,
h5 {
    font-family: 'Play', sans-serif;
    padding-left: 1rem;
}
h2 {
    color: #CC0000;
}

p {
    font-family: 'IBM Plex Serif', serif;
	padding-left: 1rem;
}
li {
    font-family: 'Open Sans', sans-serif;
}
a {
	color:black;
}
a.pdflink {
	COLOR: #000099
}
a:active {
    COLOR: #3030ff
}
a:hover {
    COLOR: #3030ff
}

.footer {
    margin: 1rem 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    color: #CE0000;
}
.footer span{
  padding: 0.5em;
}

/* Default is mobile, change is for all other sizes */
@media all and (min-width: 700px)
{
  .heading{
    flex-flow: row nowrap;
  }
  .heading-title {
    order: 0;
  }
}

@media all and (min-width: 1000px)
{
  /* Grow text while screen is different sizes */
  .heading-title {
    font-size: 2.4vw;
  }
}

@media all and (min-width: 1200px)
{
  /* Stop text growth when max width is reached */
  .heading-title {
    font-size: 2em;
  }
}

@media all and (max-width: 350px)
{
  .smallest{
    display: none;
  }
}
</style>
